import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NeoGarantiaIntermediarioDTO } from '../../Model/neoGarantiaIntermediarioDTO';
import { AdministracionGarantiaService } from '../../Service/administracionGarantia.service';
import { CurrencyPipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-administracion-garantia-intermediario',
    templateUrl: './administracion-garantia-intermediario.component.html',
    styleUrls: ['./administracion-garantia-intermediario.component.scss'],
    providers: [AdministracionGarantiaService],
    standalone: false
})
export class AdministracionGarantiaIntermediarioComponent implements OnInit {
  public listaNeoGarantiaIntermediarioDTO: NeoGarantiaIntermediarioDTO[] = [];
  public neoGarantiaIntermediarioDTO: NeoGarantiaIntermediarioDTO;
  public editarNeoGarantiaIntermediarioDTO: NeoGarantiaIntermediarioDTO;
  public eliminarNeoGarantiaIntermediarioDTO: NeoGarantiaIntermediarioDTO;
  public user;
  adminGarantiaForm: UntypedFormGroup;
  editarGarantiaForm: UntypedFormGroup;
  listaEstados: string[] = ['HABILITADA','DESHABILITADA'];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private _userIntermediarioService: UserService,
    private _administracionGarantiaService: AdministracionGarantiaService,
    public pipe: CurrencyPipe,
    private alertService: AlertService,
    public router: Router,
    private _sweetAlert:SweetAlertService
  ) {
    this.neoGarantiaIntermediarioDTO = new NeoGarantiaIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.editarNeoGarantiaIntermediarioDTO = new NeoGarantiaIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.eliminarNeoGarantiaIntermediarioDTO = new NeoGarantiaIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
    this.user = this._userIntermediarioService.getUser();
    this.adminGarantiaForm = this.formBuilder.group({
      nombre: ['', Validators.required],
      estado: ['', Validators.required],
    });
    this.editarGarantiaForm = this.formBuilder.group({
      nombre: ['', Validators.required],
      estado: ['', Validators.required],
      justificacion: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this._administracionGarantiaService
      .getCondicionIF(this.user.idCliente)
      .subscribe(
        (response) => {
          this.listaNeoGarantiaIntermediarioDTO = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los cargos y/o condiciones');
        }
      );
  }

  isValidForm(field: string) {
    return (
      (this.adminGarantiaForm.get(field)?.dirty ||
        this.adminGarantiaForm.get(field)?.touched) &&
      this.adminGarantiaForm.get(field)?.invalid
    );
  }

  isValidFormEditar(field: string) {
    return (
      (this.editarGarantiaForm.get(field)?.dirty ||
        this.editarGarantiaForm.get(field)?.touched) &&
      this.editarGarantiaForm.get(field)?.invalid
    );
  }

  onSubmit() {
    this.neoGarantiaIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.neoGarantiaIntermediarioDTO.nombre = this.adminGarantiaForm.get('nombre').value;
    this.neoGarantiaIntermediarioDTO.estado = this.adminGarantiaForm.get('estado').value;

    this.neoGarantiaIntermediarioDTO.idCliente = this.user.idCliente;
    this._administracionGarantiaService
      .saveCondicionIF(this.neoGarantiaIntermediarioDTO)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this._sweetAlert.successModal('Condición agregada');
            this.adminGarantiaForm = this.formBuilder.group({
              nombre: ['', Validators.required],
              estado: ['', Validators.required],
            });
            this.neoGarantiaIntermediarioDTO = new NeoGarantiaIntermediarioDTO(
              null,
              null,
              null,
              null,
              null,
              null
            );
            this.ngOnInit();
          } else {
            this._sweetAlert.errorModal("Error!",true,response['error']);
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'No fue posible agregar la condición');
        }
      );
    this.editarNeoGarantiaIntermediarioDTO = new NeoGarantiaIntermediarioDTO(
      null,
      null,
      null,
      null,
      null,
      null
    );
  }

  editarFila(i) {
    this.editarNeoGarantiaIntermediarioDTO =
      this.listaNeoGarantiaIntermediarioDTO[i];
    this.editarGarantiaForm
      .get('nombre')
      .setValue(this.editarNeoGarantiaIntermediarioDTO.nombre);
    this.editarGarantiaForm
      .get('estado')
      .setValue(this.editarNeoGarantiaIntermediarioDTO.estado);
    $('#editModal').modal('show');
  }



  editarGarantia() {
    if (this.editarGarantiaForm.valid) {
    this.editarNeoGarantiaIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.editarNeoGarantiaIntermediarioDTO.nombre = this.editarGarantiaForm.get('nombre').value;
    this.editarNeoGarantiaIntermediarioDTO.estado = this.editarGarantiaForm.get('estado').value;
    this.editarNeoGarantiaIntermediarioDTO.justificacion =
      this.editarGarantiaForm.get('justificacion').value;
      this._administracionGarantiaService
        .updateCondicionIF(this.editarNeoGarantiaIntermediarioDTO)
        .subscribe(
          (response) => {
            if (response['exitoso'] == true) {
              this._sweetAlert.successModal('Condición editada');
              $('#editModal').modal('hide');
              this.ngOnInit();
            } else {
              this._sweetAlert.errorModal("Error!",true,response['error']);
              $('#editModal').modal('hide');
              this.ngOnInit();
            }
          },
          (error) => {
            this._sweetAlert.errorModal("Error!",true,'No fue posible editar la condición');
            $('#editModal').modal('hide');
            this.ngOnInit();
          }
        );
      } else {
        this.editarGarantiaForm.markAllAsTouched();
      }
  }

  borrarFila(i) {
    this.eliminarNeoGarantiaIntermediarioDTO.idParametrizacionCondicion =
      this.listaNeoGarantiaIntermediarioDTO[i].idParametrizacionCondicion;
    this.eliminarNeoGarantiaIntermediarioDTO.idCliente =
      this.listaNeoGarantiaIntermediarioDTO[i].idCliente;
    this.eliminarNeoGarantiaIntermediarioDTO.idUsuario = this.user.idUsuario;
    this.eliminarNeoGarantiaIntermediarioDTO.justificacion = '';
    $('#deleteModal').modal('show');
  }

  borrarRango() {
    if (this.eliminarNeoGarantiaIntermediarioDTO != null) {
      if (this.eliminarNeoGarantiaIntermediarioDTO.justificacion != '') {
        this._administracionGarantiaService
          .deleteCondicionIF(this.eliminarNeoGarantiaIntermediarioDTO)
          .subscribe(
            (response) => {
              if (response['exitoso'] == true) {
                this._sweetAlert.successModal('Condición borrada exitosamente');
                $('#deleteModal').modal('hide');
                this.ngOnInit();
              } else {
                if (response['mensajeError']) {
                  this._sweetAlert.errorModal("Error!",true,response['mensajeError']);
                } else {
                  this._sweetAlert.errorModal("Error!",true,'No fue posible borrar la condición');
                }
                $('#deleteModal').modal('hide');
              }
            },
            (error) => {
              this._sweetAlert.errorModal("Error!",true,'No fue posible borrar la condición');
              $('#deleteModal').modal('hide');
            }
          );
      } else {
        this._sweetAlert.errorModal("Error!",true,'Ingrese la justificación');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'No fue posible cargar los datos');
      $('#deleteModal').modal('hide');
    }
  }


  goHome() {
    this.router.navigate(['/intermediario/home']);
  }
}
